// src/Can.js
import React from "react";
import { AbilityBuilder, Ability } from "@casl/ability";
import { createContextualCan } from "@casl/react";

// 1. Context ve <Can> bileşeni (mevcut)
export const AbilityContext = React.createContext();
// CASL Consumer bekliyor; Context nesnesini doğrudan çizmek React 18.3'te kaldırılacak (konsol uyarısı)
export const Can = createContextualCan(AbilityContext.Consumer);

// 2. Kullanıcının allowedPages listesine göre Ability tanımlayan fonksiyon
export function defineAbilityFor(user) {
    const { can, cannot, rules } = new AbilityBuilder(Ability);

    if (user?.role?.allowedPages?.length) {
        // her sayfa için view yetkisi
        user.role.allowedPages.forEach((route) => {
            can("view", route);
        });
    }

    // opsiyonel: admin rolü varsa her şeyi yönetebilir
    if (user?.role?.name === "admin") {
        can("manage", "all");
    }

    return new Ability(rules);
}
